export const CycleCountStatus = {
  Closed: "Closed",
  Created: "Created",
  Open: "Open",
  Deleted: "Deleted",
};

export const DEFAULT_FILTER_USER_SECTION = "options";
export const DEFAULT_FILTER_USER_PARAMETER = "defaultFilterForIssueScreen";

export const ModuleNames = {
  Item: "Item",
  WorkOrder: "Work Order",
  Requisition: "Requisition"
};

export const DocumentProviderType ={
  ApteanADP: "Aptean ADP"
};

export const WorkOrderType = {
  Routine: "Routine"
};

export const WorkOrderStatus = {
  Completed: 70,
  Canceled: 80,
};

export const ApplicationDetails = {
  ApplicationType: "EAMMobile",
  DisplayName: "EAMMobile App",
};
